// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----styles-module---footer---2Ymu3","nav":"src-components-Footer----styles-module---nav---3T5SR","links":"src-components-Footer----styles-module---links---bq2vO","icon":"src-components-Footer----styles-module---icon---334r8","routes":"src-components-Footer----styles-module---routes---2FqlA","copyright":"src-components-Footer----styles-module---copyright---3KzVs","logo":"src-components-Footer----styles-module---logo---2dUJo","link":"src-components-Footer----styles-module---link---3027N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/styles.module.css
// module id = 500
// module chunks = 114276838955818